import { WeeklyScheduleDTO } from 'types';

export const isWeeklyScheduleEmpty = (weeklySchedule: WeeklyScheduleDTO) => {
    const { days } = weeklySchedule;
    return days.every((day) => !day.description);
};
